
const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/06ebc79c2a41a058707f14422dee0305.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-dark/70 via-dark/50 to-dark/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-left w-full">
        <div className="max-w-3xl">
          <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <p className="text-white text-sm font-medium">
              Servicio profesional en <a href="https://es.wikipedia.org/wiki/Mollet_del_Vall%C3%A9s" target="_blank" rel="noopener noreferrer" className="underline hover:text-secondary transition-colors">Mollet del Vallès</a> y Vallès Oriental
            </p>
          </div>

          <h1 className="text-white font-bold mb-6 leading-tight">
            <span className="block text-5xl md:text-6xl lg:text-7xl">
              Vaciado de pisos y limpieza extrema
            </span>
            <span className="block text-4xl md:text-5xl lg:text-6xl mt-2 text-secondary">
              en Mollet del Vallès
            </span>
          </h1>

          <p className="text-white/90 text-xl md:text-2xl mb-10 leading-relaxed max-w-2xl">
            Especialistas en vaciado de pisos, locales y limpieza por síndrome de Diógenes. Servicio discreto, profesional y con más de 10 años de experiencia en el Vallès Oriental.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+34602365996"
              className="group relative inline-flex items-center justify-center space-x-3 bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg overflow-hidden transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-700"></span>
              <i className="ri-phone-fill text-2xl relative z-10"></i>
              <span className="relative z-10">Llamar Ahora 602 36 59 96</span>
            </a>

            <a
              href="https://wa.me/34602365996"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative inline-flex items-center justify-center space-x-3 border-2 border-white bg-transparent text-white px-8 py-4 rounded-lg font-semibold text-lg overflow-hidden transition-all duration-300 hover:bg-white hover:text-dark cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill text-2xl text-[#25D366]"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
